var _excluded = ["children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useMemo } from 'react';
import { useSiteChromeStaticContext } from "../SiteChromeStaticContext/useSiteChromeStaticContext";
import { UserContext } from "./UserContext";
import { useAuthentication } from "../../hooks/useAuthentication";
import { useBasket } from "../../hooks/useBasket";
import { useFavourites } from "../../hooks/useFavourites";
import { useMembership } from "../../hooks/useMembership";
export var UserContextProvider = function UserContextProvider(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useSiteChromeStaticC = useSiteChromeStaticContext(),
    cookies = _useSiteChromeStaticC.cookies,
    env = _useSiteChromeStaticC.env,
    mergeBasket = _useSiteChromeStaticC.mergeBasket;
  var userAuthenticated = useAuthentication();
  var _useMembership = useMembership(),
    membershipIsActive = _useMembership.membershipIsActive;
  var basketItemsCount = useBasket({
    cookies,
    env,
    mergeBasket
  });
  var hasFavouriteProducts = useFavourites(env);
  var userContextValue = useMemo(function () {
    return {
      userAuthenticated,
      membershipIsActive,
      basketItemsCount,
      hasFavouriteProducts
    };
  }, [userAuthenticated, membershipIsActive, basketItemsCount, hasFavouriteProducts]);
  return /*#__PURE__*/React.createElement(UserContext.Provider, _extends({
    value: userContextValue
  }, props), children);
};